module.exports = __webpack_public_path__ + "media/images/ohap_my apps_on-bcbc08c789ed22602c2170608fdc255e.png";